import { RxFontBold } from 'react-icons/rx';

import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import classNames from 'classnames';

import { SELECT_BOLD } from './BoldPlugin';

export const BoldButton = ({ isBold }: { isBold: boolean }) => {
  const [editor] = useLexicalComposerContext();

  return (
    <button
      type="button"
      className={classNames(
        'text-gray-7 flex h-6 w-6 items-center justify-center rounded-sm border-none',
        isBold && 'bg-gray-2'
      )}
      onClick={() => {
        editor.dispatchCommand(SELECT_BOLD, { isBold: !isBold });
        editor.focus();
      }}
    >
      <RxFontBold className="text-gray-7 h-5 w-5" />
    </button>
  );
};
